import { SORT_QUERY_PARAMETER_NAME } from 'config/constants';
import { getQueryWithoutSlugTypeParameterFromParsedUrlQuery } from 'helpers/parsing/urlParsing';
import { useRouter } from 'next/router';
import { UrlQueries } from 'types/urlQueries';

export const useCurrentSortQuery = () => {
    const router = useRouter();
    const query = getQueryWithoutSlugTypeParameterFromParsedUrlQuery(router.query) as UrlQueries;
    const sortQuery = query[SORT_QUERY_PARAMETER_NAME] ?? null;

    return sortQuery;
};
